
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.1 34V15.9H15.9v18.2h18.2zm-9-5.06a3.87 3.87 0 113.9-3.88 3.86 3.86 0 01-3.9 3.86z","fill":"var(--primary-highlight)"}}),_c('path',{attrs:{"d":"M25 .49A24.51 24.51 0 1049.51 25 24.51 24.51 0 0025 .49zM38 38H12.05V12.05H38z","fill":"var(--primary-highlight)"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/chambreFill.svg